export default __webpack_public_path__ + "static/media/chat12.59aa5262.png";